export default {"src":"/_next/static/media/dice_24.4bb2b415.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};